// src/models/landing-page.js
import personsservice from '@/services/persons/personsservice';

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
export class Event {
  constructor({
    id = null,
    name = '',
    email = '',
  } = {}) {
    this.id = id
    this.name = name
    this.email = email
  }
}

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
//export function responseAdapter({ fields, sys }) {
//  return new Event({ ...fields, ...sys });
//}

export function responseAdapter(response) {
  return response.data;
}

export default {
  async getAll() {
    return responseAdapter(await personsservice.getAll());
  },
  
};
